<template>
    <DDropdown
        add-menu-classes="pt-0"
        icon="account-outline"
        :toggler-text="userName"
        color="secondary"
        :caret="false"
    >
        <DDropdownItem
            id="user-dropdown-profile"
            class="user-dropdown-item"
            @click="editLink"
        >
            <DIcon name="account" />
            <span>{{ $t('header.profile') }}</span>
        </DDropdownItem>
        <DDropdownItem
            id="user-dropdown-logout"
            class="user-dropdown-item"
            @click="logout"
        >
            <DIcon name="logout" />
            <span>{{ $t('header.logout') }}</span>
        </DDropdownItem>
    </DDropdown>
</template>

<script>
import { router } from '@inertiajs/vue3'

export default {
    name: 'DUserDropdown',
    props: {
        userName: {
            type: String,
            required: false,
            default: ''
        },
        userId: {
            type: Number,
            default: 0
        }
    },
    methods: {
        logout () {
            router.post(this.$route('logout'))
        },
        editLink () {
            router.get(this.$route('users.edit', { user: this.userId }))
        }
    }
}
</script>

<style lang="scss" scoped>
.user-link {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 0px 10px;
    border: 1px solid rgba(0,0,0,0.14);
    padding: 3px 10px;
    border-radius: 5px;
    height: 40px;
    justify-items: center;

    & div:nth-child(1) {
        color: rgba(0,0,0,0.4);
    }

    &:hover {
        background: rgba(0,0,0,0.07);
    }
}
.user-dropdown-item {
    display: grid;
    grid-template-columns: 20px 1fr;
    grid-gap: 15px;
    align-items: center;
}
</style>
